(function () {
  const RESULT_CONTAINER_SELECTOR =
    'body[data-template="collection"] #ProductGridContainer, body[data-template="search"] #ProductGridContainer';
  const SENTINEL_SELECTOR = '[id^="sentinel_"], #sentinel_search_loader';
  const NEXT_PAGE_SELECTOR = '.pagination__item--prev[href]';
  // Keep the original storage key for compatibility with already-saved
  // collection sessions; the payload now supports collection and search lists.
  const PRODUCT_LIST_RETURN_STATE_KEY = 'pcy:collection-return-state';

  function isProductLink(link) {
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return false;
    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && /\/products\//.test(url.pathname);
    } catch (_) {
      return false;
    }
  }

  function isProductListPage() {
    return document.body.matches('[data-template="collection"], [data-template="search"]');
  }

  function saveProductListReturnState(event) {
    if (!isProductListPage()) return;
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest?.('a[href]');
    if (!isProductLink(link)) return;

    const container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    const cachedContainer = container.cloneNode(true);
    cachedContainer.querySelectorAll(SENTINEL_SELECTOR).forEach((sentinel) => sentinel.remove());
    cachedContainer.querySelectorAll('.infinite_mf2311bc_loader').forEach((loader) => loader.remove());
    cachedContainer.classList.remove('loading');

    try {
      sessionStorage.setItem(
        PRODUCT_LIST_RETURN_STATE_KEY,
        JSON.stringify({
          url: `${window.location.pathname}${window.location.search}`,
          scrollY: window.scrollY,
          gridHTML: cachedContainer.innerHTML,
          savedAt: Date.now(),
        })
      );
    } catch (_) {
      // Storage can be unavailable or full. Native browser restoration remains
      // the fallback in that case.
    }

    // Some navigation/app scripts add `body.loading` during the same click.
    // Clear it after all click handlers have run so the BFCache snapshot keeps
    // the visible product list instead of the full-screen loading overlay.
    queueMicrotask(() => document.body.classList.remove('loading'));
  }

  function restoreProductListReturnState(options = {}) {
    if (!isProductListPage()) return;

    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    if (!options.fromPageCache && (!navigation || navigation.type !== 'back_forward')) return;

    let state;
    try {
      state = JSON.parse(sessionStorage.getItem(PRODUCT_LIST_RETURN_STATE_KEY) || 'null');
    } catch (_) {
      return;
    }

    const currentUrl = `${window.location.pathname}${window.location.search}`;
    if (!state || state.url !== currentUrl || !state.gridHTML || Date.now() - state.savedAt > 30 * 60 * 1000) return;

    const container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    // BFCache already contains the exact live DOM. Replacing it would discard
    // element state and event listeners, so only restore HTML after a real
    // back/forward document reload.
    if (!options.fromPageCache) container.innerHTML = state.gridHTML;
    document.body.classList.remove('loading');
    container.classList.remove('loading');
    document.documentElement.classList.remove('pcy-restoring-product-list');

    const restoreScroll = () => window.scrollTo({ top: Number(state.scrollY) || 0, left: 0, behavior: 'instant' });
    restoreScroll();
    requestAnimationFrame(() => {
      restoreScroll();
      requestAnimationFrame(restoreScroll);
    });
    window.addEventListener('load', restoreScroll, { once: true });

    if (!options.keepState) {
      try {
        sessionStorage.removeItem(PRODUCT_LIST_RETURN_STATE_KEY);
      } catch (_) {}
    }
  }

  function prepareProductListForPageCache() {
    if (!isProductListPage()) return;
    document.body.classList.remove('loading');
    document.querySelector('#ProductGridContainer')?.classList.remove('loading');
    document.documentElement.classList.remove('pcy-restoring-product-list');
  }

  function handleProductListPageShow(event) {
    if (!event.persisted) return;
    restoreProductListReturnState({ fromPageCache: true });
    disableOrphanedSentinels(document);
  }

  function disableOrphanedSentinels(root) {
    const containers = root.matches?.(RESULT_CONTAINER_SELECTOR)
      ? [root]
      : Array.from(root.querySelectorAll?.(RESULT_CONTAINER_SELECTOR) || []);

    containers.forEach((container) => {
      const hasNextPage = Boolean(container.querySelector(NEXT_PAGE_SELECTOR));
      container.dataset.hasNextPage = String(hasNextPage);

      // Slow connections can make the app append another sentinel before the
      // previous request settles. Keep the original (possibly already loading)
      // sentinel and remove later duplicates before their observers can fire.
      const appSentinels = Array.from(container.querySelectorAll('[id^="sentinel_"]'));
      if (appSentinels.length > 1) {
        appSentinels.slice(1).forEach((sentinel) => sentinel.remove());
      }

      if (hasNextPage) return;

      container.querySelectorAll(SENTINEL_SELECTOR).forEach((sentinel) => {
        sentinel.hidden = true;
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function initialize() {
    restoreProductListReturnState();
    document.documentElement.classList.remove('pcy-restoring-product-list');
    disableOrphanedSentinels(document);

    document.addEventListener('click', saveProductListReturnState, true);
    window.addEventListener('pagehide', prepareProductListForPageCache);
    window.addEventListener('pageshow', handleProductListPageShow);

    // Sadece urun izgarasi konteynerlerini izle — tum document.body'yi
    // izlemek (header, mini-cart, wishlist butonlari vb. her DOM
    // degisiminde bu callback'i tetikleyip) infinite scroll sirasinda ana
    // thread'i gereksiz yere mesgul edip yeni urunlerin gorunmesini
    // yavaslatiyordu.
    const resultContainers = document.querySelectorAll(RESULT_CONTAINER_SELECTOR);
    if (resultContainers.length) {
      const observer = new MutationObserver((mutations) => {
        if (!mutations.some((mutation) => mutation.addedNodes.length > 0)) return;
        disableOrphanedSentinels(document);
      });
      resultContainers.forEach((container) => observer.observe(container, { childList: true, subtree: true }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
